import { searchInoviceDocumentDetail } from 'api/documentBus'
import DocumentDetailIvend from 'Components/DocumentDetailIvend'
import { t } from 'i18next'
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { ROUTES } from 'Utils/constants'

function InvoiceDetail() {
  const { id } = useParams()

  const [loadingData, setLoadingData] = useState(false)
  const [detailInvoice, setDetailInvoice] = useState([])
  const [messageError, setMessageError] = useState('')

  const columns = [
    {
      Header: t('DETAIL_DOCUMENTS_T.REFERENCE_HEADER'),
      accessor: t('DETAIL_DOCUMENTS_T.REFERENCE_ACCESOR'),
      width: '10%',
      arrowOrderEnabled: true,
    },
    {
      Header: t('DETAIL_DOCUMENTS_T.DESCRIPTION_LABEL'),
      accessor: t('DETAIL_DOCUMENTS_T.DESCRIPTION_ACCESOR'),
      width: '40%',
      arrowOrderEnabled: true,
    },
    {
      Header: t('DETAIL_DOCUMENTS_T.QTY_HEADER'),
      accessor: t('DETAIL_DOCUMENTS_T.QTY_ACCESOR'),
      width: '10%',
      arrowOrderEnabled: true,
    },
    {
      Header: t('DETAIL_DOCUMENTS_T.UNITY_PRICE_HEADER'),
      accessor: t('DETAIL_DOCUMENTS_T.UNITY_PRICE_ACCESOR'),
      width: '10%',
      arrowOrderEnabled: true,
    },
    {
      Header: t('DETAIL_DOCUMENTS_T.DISCOUNT_HEADER'),
      accessor: t('DETAIL_DOCUMENTS_T.DISCOUNT_ACCESOR'),
      width: '10%',
      arrowOrderEnabled: true,
    },
    {
      Header: t('DETAIL_DOCUMENTS_T.PRECIO_TOTAL_HEADER'),
      accessor: t('DETAIL_DOCUMENTS_T.PRECIO_TOTAL_ACCESOR'),
      width: '10%',
      arrowOrderEnabled: true,
    },
    {
      Header: t('DETAIL_DOCUMENTS_T.FULFILLMENTPLAN_HEADER'),
      accessor: t('DETAIL_DOCUMENTS_T.FULFILLMENTPLAN_ACCESOR'),
      width: '10%',
      arrowOrderEnabled: true,
    },
  ]

  const combinedArray = [
    detailInvoice?.RelationalDocs?.Quote && {
      Type: 'quote',
      Name: 'Cotización',
      DocumentTypeId: detailInvoice.RelationalDocs.Quote.QuoteHeaderId,
      Path: ROUTES.editQuoteHeaderId,
      ...detailInvoice.RelationalDocs.Quote,
    },
    ...(Array.isArray(detailInvoice?.RelationalDocs?.SalesOrders)
      ? detailInvoice.RelationalDocs.SalesOrders.map(order => ({
          Type: 'salesOrder',
          Name: 'Orden de venta',
          DocumentTypeId: order?.SaleOrderHeaderId,
          Path: ROUTES.salesOrder,
          ...order,
        }))
      : []),
    ...(Array.isArray(detailInvoice.RelationalDocs?.RelatedReturns)
      ? detailInvoice.RelationalDocs?.RelatedReturns.map(doc => ({
          Type: 'return',
          Name: 'Devolución',
          DocumentTypeId: doc?.ReturnId,
          DocumentNumber: doc?.ReturnId,
          Path: ROUTES.repaymentDetail,
          ...doc,
        }))
      : []),
    ...(Array.isArray(detailInvoice?.RelationalDocs?.RequestDispatchs) &&
    detailInvoice.RelationalDocs.RequestDispatchs.length > 0
      ? detailInvoice.RelationalDocs.RequestDispatchs.map(dispatch => ({
          Type: 'requestDispatch',
          Name: 'Despacho',
          DocumentTypeId: dispatch?.RequestDispatchHeaderId,
          Path: ROUTES.orderDispatch,
          ...dispatch,
        }))
      : []),
    detailInvoice?.RelationalDocs?.ElectronicInvoice && {
      Type: 'electronicInvoice',
      Name: 'Factura electrónica',
      DocumentTypeId:
        detailInvoice.RelationalDocs.ElectronicInvoice.ElectronicInvoiceId,
      ...detailInvoice.RelationalDocs.ElectronicInvoice,
    },
    ...(Array.isArray(detailInvoice?.RelationalDocs?.PurchaseOrders)
      ? detailInvoice.RelationalDocs.PurchaseOrders.map(purchaseOrder => ({
          Type: 'purchaseOrders',
          Name: 'Orden de compra',
          ...purchaseOrder,
        }))
      : []),
  ].filter(Boolean)

  const fetchDocument = async (docId = null) => {
    setLoadingData(true)
    try {
      const { Data } = await searchInoviceDocumentDetail(docId)

      const isValidDataService = Data && Object.keys(Data).length > 0

      if (isValidDataService) {
        setDetailInvoice(Data)
      }
    } catch (error) {
      const message = error?.response?.data?.Message
      if (message) setMessageError(message)
    } finally {
      setLoadingData(false)
    }
  }
  useEffect(() => {
    fetchDocument(id)
  }, [id])

  return DocumentDetailIvend({
    loadingData,
    data: detailInvoice,
    combinedArray,
    columns,
    title: 'DETAIL_DOCUMENTS_T.INVOICE_TITLE',
    isInvoice: true,
    dataTestId: 'container-invoice-detail',
    messageError,
    setMessageError,
  })
}

export default InvoiceDetail
